import React from 'react';
// import '../../style.css';
import Amplify, { Auth } from 'aws-amplify';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import 'react-dropdown/style.css';
import Loader from 'react-loader';
import Tooltip from '@material-ui/core/Tooltip';
import SideMenu from '../sideMenu/sideMenu';
import docIcon from '../../../src/images/doc-icon.png'
import zipIcon from '../../../src/images/zip-icon.png'
import mediaIcon from '../../../src/images/media-icon.png'
// import loader from '../../images/Spin-1s-107px.gif';
import {
  getSettlementById, saveSettlementAnswers, saveEnrollmenttDoc, updateEnrollmenttDoc,
  saveEnrollmentAuthorization, getPendingRequiredDocUser, getPendingRequiredDocUserDelete,
  moveToNextQuestionList,
  getEligibilityQuestionById,
  saveToNextQuestionList, getPendingSettlementQuestions, saveSettlementWithoutData,
} from '../../Actions/actions';
import * as SecretKeys from '../../ENV.json';

Amplify.configure(SecretKeys.awsUserpool);

// const ext = ['docx', 'doc', 'png', 'jpg', 'jpeg', 'pdf', 'DOCX', 'DOC', 'PNG', 'JPG', 'JPEG', 'PDF'];
const extDoc = ['docx', 'doc', 'DOCX', 'DOC', 'csv', 'xls', 'xlsx', 'txt'];
const extPdf = ['pdf', 'PDF'];

class applyContainerDocument extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Urlparams: [],
      ShowUploadScreen: true,
      successUpload: false,
      enrollmentId: '',
      loaded: false,
      UserName: '',
      uploadCount: 0,
      // RequireDocCount: 0,
      UploadError: false,
      UploadMessageError: false,
      settlementUserId: localStorage.getItem('userId'),
      pendingSettlementDOc1: [],
      UploadENrolmentDocResponse1: [],
      UpdateUploadENrolmentDocResponse1: [],
      requiredDocStatus: true,
      intervalId: 0,


    };
    this.getTheUploadDoc = this.getTheUploadDoc.bind(this);
    this.handleChangeFile = this.handleChangeFile.bind(this);
    this.getSecondPart = this.getSecondPart.bind(this);
    this.completeSteps = this.completeSteps.bind(this);
    this.onChange = this.onChange.bind(this);
    this.setStateCmh = this.setStateCmh.bind(this);
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  scrollStep = () => {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  }

  componentDidMount() {
    const { match: { params } } = this.props;
    const postObject = {};
    postObject.id = params.eid;
    const dataa = { userId: this.state.settlementUserId, settlementId: this.props.match.params.eid };
    this.props.getPendingRequiredDocUser(dataa);
    this.props.getSettlementById({ id: params.eid });
    this.setState({ loaded: true });

    this.setState({
      Urlparams: params.eid,
    });
    const dataaSettel = { id: this.props.match.params.eid, userId: this.state.settlementUserId };
    this.props.moveToNextQuestionList(dataaSettel);
  }

  componentWillMount() {
    if (localStorage.getItem('paymentStatus') === 'pending') {
      localStorage.clear();
      Auth.signOut().then(async () => {
        await this.props.logoutUser();
        this.props.clearDataEmail();
      }).catch(error => error);
    }
    const intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
    this.setState({
      intervalId,
    });
    this.forceUpdate();
  }

  setStateCmh() {
    this.setState({
      ShowUploadScreen: false,
    });
  }

  getTheUploadDoc(enrollmentId) {
    if (enrollmentId !== '') {
      const data = { enrollmentId: 0, settlementId: this.state.Urlparams };
      this.props.getPendingRequiredDocUser(data);
      this.setState({
        loaded: false,
      });
    }
  }

  componentDidUpdate() {
    const {
      UploadENrolmentDocResponse, UpdateUploadENrolmentDocResponse, pendingSettlementDOcUser, pendingSettlementDOcUserDelete,
    } = this.props.data;
    const {
      UploadENrolmentDocResponse1, UpdateUploadENrolmentDocResponse1, pendingSettlementDOc1, requiredDocStatus, pendingSettlementDOcUserDeleteData,
    } = this.state;
    if (UploadENrolmentDocResponse !== undefined && UploadENrolmentDocResponse.length > 0) {
      if (UploadENrolmentDocResponse1 !== UploadENrolmentDocResponse) {
        const dataa = { userId: this.state.settlementUserId, settlementId: this.props.match.params.eid };
        setTimeout(() => {
          this.props.getPendingRequiredDocUser(dataa);
        }, 1000);

        this.setState({ UploadENrolmentDocResponse1: UploadENrolmentDocResponse });
      }
    }

    if (UpdateUploadENrolmentDocResponse !== undefined && UpdateUploadENrolmentDocResponse.length > 0) {
      if (UpdateUploadENrolmentDocResponse1 !== UpdateUploadENrolmentDocResponse) {
        const dataa = { userId: this.state.settlementUserId, settlementId: this.props.match.params.eid };
        setTimeout(() => {
          this.props.getPendingRequiredDocUser(dataa);
        }, 1000);

        this.setState({ UpdateUploadENrolmentDocResponse1: UpdateUploadENrolmentDocResponse });
      }
    }
    if (pendingSettlementDOcUserDelete !== pendingSettlementDOcUserDeleteData) {
      this.setState({
        pendingSettlementDOcUserDeleteData: pendingSettlementDOcUserDelete,
      });
      const dataa = { userId: this.state.settlementUserId, settlementId: this.props.match.params.eid };

      this.props.getPendingRequiredDocUser(dataa);
    }


    if (pendingSettlementDOcUser !== pendingSettlementDOc1) {
      if (pendingSettlementDOcUser !== undefined) {
        // let UploadDocValue = 0;
        // let i;
        // for (i = 0; i < pendingSettlementDOcUser.length; i++) {
        //   if (pendingSettlementDOcUser[i].mandatory === 1 && pendingSettlementDOcUser[i].enrollmentDocumentDto === undefined) {
        //     UploadDocValue += 1;
        //   }
        // }
        this.setState({
          pendingSettlementDOc1: pendingSettlementDOcUser,
          enrollmentId: pendingSettlementDOcUser.length ? pendingSettlementDOcUser[0].enrollmentId !== undefined ? pendingSettlementDOcUser[0].enrollmentId : 0 : 0,
        });
        if (pendingSettlementDOcUser.length > 0 && requiredDocStatus === true) {
          this.setState({
            // RequireDocCount: UploadDocValue,
            requiredDocStatus: false,
          });
        }
        this.setState({ loaded: true });
      }
    }
  }


  handleChangeFile(event, id) {
    // const { uploadCount } = this.state;
    const file = event.target.files[0];

    // if (ext.indexOf(file.name.split('.').pop()) > -1) {
    this.setState({
      loaded: false,
      UploadError: false,
      UploadMessageError: false,
    });
    // const file = event.target.files[0];
    const formData = new FormData();
    const enrollmentId = this.state.enrollmentId;
    formData.append('documentContentType', file.name.split('.').pop());
    // console.log('event.target.files[0].type',file.name.split(".").pop())
    // formData.append('documentContentType', this.getSecondPart(event.target.files[0].type));
    formData.append('name', event.target.files[0].name); // type, size
    formData.append('documentFileSize', event.target.files[0].size);
    formData.append('enrollmentId', enrollmentId); //
    formData.append('settlementId', this.state.Urlparams);
    if (id !== undefined && id !== '') {
      formData.append('id', id); //
    }
    formData.append('userId', this.state.settlementUserId); //
    formData.append('file', file);
    formData.append('requiredDocId', event.target.id);
    if (id !== undefined && id !== '') {
      this.props.updateEnrollmenttDoc(formData);
    } else {
      // this.props.saveEnrollmenttDoc(formData);
    }
    // let i;
    // for (i = 0; i < this.state.pendingSettlementDOc1.length; i++) {
    //   if (this.state.pendingSettlementDOc1[i].name === event.target.name) {
    //     if (this.state.pendingSettlementDOc1[i].mandatory === 1 && this.state.pendingSettlementDOc1[i].enrollmentDocumentDto === undefined) {
    //       this.setState({
    //         uploadCount: uploadCount + 1,
    //         UploadError: false,
    //       });
    //     }
    //   }
    // }
    // } else {
    //   this.setState({
    //     UploadMessageError: true,
    //   });
    // }
  }


  handleChangeFileMultiple = (event, id) => {
    const fileList = Array.from(event.target.files);
    // if ((fileList.findIndex(item1 => (ext.indexOf(item1.name.split('.').pop()) > -1) === false) !== -1) === false) {
    const formData = new FormData();
    this.setState({
      loaded: false,
      UploadError: false,
      UploadMessageError: false,
    });
    // console.log('ssssssssssssssss val().split(".").pop().toLowerCase() ', fileList, ext);
    // console.log(fileList.findIndex(item1 => (ext.indexOf(item1.name.split('.').pop()) > -1) === false) !== -1);

    // console.log('file', fileList, event.target.files[0], event.target.value, id);
    const enrollmentId = this.state.enrollmentId;
    // formData.append('documentContentType', file.name.split('.').pop());
    // console.log('event.target.files[0].type',file.name.split(".").pop())
    // formData.append('documentContentType', this.getSecondPart(event.target.files[0].type));
    // formData.append('name', event.target.files[0].name); // type, size
    // formData.append('documentFileSize', event.target.files[0].size);
    formData.append('enrollmentId', enrollmentId); //
    formData.append('settlementId', this.state.Urlparams);
    if (id !== undefined && id !== '') {
      formData.append('id', id); //
    }
    formData.append('userId', this.state.settlementUserId); //
    for (let x = 0; x < fileList.length; x++) {
      formData.append('file', fileList[x]);
    }
    // formData.append('file', file);
    formData.append('requiredDocId', event.target.id);
    if (id !== undefined && id !== '') {
      this.props.updateEnrollmenttDoc(formData);
    } else {
      this.props.saveEnrollmenttDoc(formData);
    }
    // for (i = 0; i < this.state.pendingSettlementDOc1.length; i++) {
    //   if (this.state.pendingSettlementDOc1[i].name === event.target.name) {
    //     if (this.state.pendingSettlementDOc1[i].mandatory === 1 && this.state.pendingSettlementDOc1[i].enrollmentDocumentDto === undefined) {
    //       this.setState({
    //         uploadCount: uploadCount + 1,
    //         UploadError: false,
    //       });
    //     }
    //   }
    // }
    // } else {
    //   this.setState({
    //     UploadMessageError: true,
    //   });
    // }
  }

  getSecondPart(str) {
    return str.split('/')[1];
  }

  deleteDoc = (id) => {
    this.setState({ loaded: false });
    this.props.getPendingRequiredDocUserDelete({ id });
  }

  completeSteps() {
    const { pendingSettlementDOc1 } = this.state;
    if (pendingSettlementDOc1.findIndex(item1 => (item1.mandatory === 1 && item1.enrollmentDocumentDtoList.length === 0)) !== -1) {
      this.setState({
        UploadError: true,
      });
    } else {
      this.setState({
        UploadError: false,
        UploadMessageError: false,
        successUpload: true,
      });
      // this.props.history.push('/enrollment');
    }

    // if (this.state.uploadCount !== this.state.RequireDocCount) {
    //   this.setState({
    //     UploadError: true,
    //   });
    // } else {
    //   this.setState({
    //     UploadError: false,
    //   });
    //   // this.props.history.push('/enrollment');
    // }
  }

  render() {
    const {
      pendingSettlementDOc1, UserName, UploadError, UploadMessageError, successUpload,
    } = this.state;
    const { settlementQuestionList: { categoryImage, categoryName, shortName } } = this.props.data;
    const ShowUploadScreen = this.state.ShowUploadScreen;
    const UploadFields = [];


    if (pendingSettlementDOc1 !== undefined && pendingSettlementDOc1.code !== 400 && Object.keys(pendingSettlementDOc1).length > 0) {
      pendingSettlementDOc1.map((item, index) => {
        if (item.mandatory === 1) {
          UploadFields.push(
            <div className="uploadDoc" key={index}>
              <label className="file-name-upload">
                {item.name}
                {' '}
                *
              </label>
              {
                item.enrollmentDocumentDtoList.length > 0

                  ? (
                    <div className="upload-doc-multi">

                      <ul className="listDefault">
                        {' '}
                        {item.enrollmentDocumentDtoList.map(docList => (
                          <li key={docList.id}>
                            {/* <div className="col s7"> */}
                            {extPdf.indexOf(docList.documentFileName.split('.').pop()) > -1 ? (<img src={docIcon}></img>) : extDoc.indexOf(docList.documentFileName.split('.').pop()) > -1 ? (<img src={docIcon}></img>) : (<img src={docList.documentContentType == "image/jpeg" ? docList.documentFilePath : (docList.documentContentType == "application/msword" || docList.documentContentType == "application/vnd.ms-excel" || docList.documentContentType == "application/vnd.openxmlformats-officedocument.wordprocessingml.document" || docList.documentContentType == "application/vnd.oasis.opendocument.text") ? docIcon : docList.documentContentType == "application/zip" ? zipIcon : docList.documentContentType == "audio/mpeg" || docList.documentContentType == "video/mp4" ? mediaIcon : docIcon} alt={docList.documentFileName} />
                            )}
                            {/* <img src={docList.documentFilePath} alt={docList.documentFileName} /> */}
                            <span className="document-name">
                              <Tooltip
                                id="tooltip-icon"
                                title="Click here to view document"
                              >
                                <a
                                  className=" "
                                  target="_blank"
                                  href={docList.documentFilePath}
                                >
                                  {docList.documentFileName}
                                </a>


                              </Tooltip>
                              {console.log('docList', docList)}
                            </span>
                            <input className="multiple-file-input" type="file" id={docList.id} name={docList.name} onChange={e => this.handleChangeFile(e, docList.id)} />
                            <a
                              className="settlement-relevant save-changes"
                              onClick={() => this.deleteDoc(docList.id)}
                            >
                              <span className="hide hide-seetlementtext">Hide&nbsp;</span>
                              {' '}
                              <i className="material-icons">delete</i>
                            </a>
                            {/* </div>
                          <div className="col s5 right-align">
                          <input type="file" title="" id={item.id} name={item.name} onChange={e => this.handleChangeFile(e, docList.enrollmentId)} />


                          </div> */}
                          </li>
                        ))
                        }
                      </ul>

                      <label> Upload multiple files</label>
                      <input type="file" title="" id={item.id} multiple name={item.name} size="" onChange={this.handleChangeFileMultiple} />

                    </div>
                  )


                  : (<div className="upload-doc-multi" ><label> Upload multiple files</label><input type="file" title="" id={item.id} multiple name={item.name} size="" onChange={this.handleChangeFileMultiple} /></div>)
              }
              {' '}
            </div>,
          );
        }

        // else if (item.enrollmentDocumentDto !== undefined) {
        //   UploadFields.push(
        //     <div className="uploadDoc" key={index}>
        //       <div className="col s7">
        //         <label className="file-name-upload">{item.name}</label>
        //         <input type="file" multiple id={item.id} name={item.name} onChange={e => this.handleChangeFileMultiple(e, (item.enrollmentDocumentDto !== undefined) ? item.enrollmentDocumentDto.id : '')} />
        //       </div>
        //       <div className="col s5 right-align">
        //         <Tooltip
        //           id="tooltip-icon"
        //           title="Click here to view document"
        //         >
        //           <a
        //             target="_blank"
        //             href={item.enrollmentDocumentDto.documentFilePath}
        //           >
        //               View Uploaded Document
        //           </a>

        //         </Tooltip>
        //       </div>
        //     </div>,
        //   );
        // }
        else {
          UploadFields.push(
            <div className="uploadDoc" key={index}>
              <label className="file-name-upload">
                {item.name}
                {' '}

              </label>
              {
                item.enrollmentDocumentDtoList.length > 0

                  ? (
                    <div className="upload-doc-multi">

                      <ul className="listDefault">
                        {' '}
                        {item.enrollmentDocumentDtoList.map(docList => (
                          <li key={docList.id}>
                            {/* <div className="col s7"> */}
                            {extPdf.indexOf(docList.documentFileName.split('.').pop()) > -1 ? (<i className="large material-icons">description</i>) : extDoc.indexOf(docList.documentFileName.split('.').pop()) > -1 ? (<i className="large material-icons">description</i>) : (<img src={docList.documentFilePath} alt={docList.documentFileName} />
                            )}
                            {/* <img src={docList.documentFilePath} alt={docList.documentFileName} /> */}
                            <span className="document-name">
                              <Tooltip
                                id="tooltip-icon"
                                title="Click here to view document"
                              >
                                <a
                                  className=" "
                                  target="_blank"
                                  href={docList.documentFilePath}
                                >
                                  {docList.documentFileName}
                                </a>


                              </Tooltip>
                            </span>
                            <input className="multiple-file-input" type="file" id={docList.id} name={docList.name} onChange={e => this.handleChangeFile(e, docList.id)} />
                            <a
                              className="settlement-relevant save-changes"
                              onClick={() => this.deleteDoc(docList.id)}
                            >
                              <span className="hide hide-seetlementtext">Hide&nbsp;</span>
                              {' '}
                              <i className="material-icons">delete</i>
                            </a>
                            {/* </div>
                          <div className="col s5 right-align">
                          <input type="file" title="" id={item.id} name={item.name} onChange={e => this.handleChangeFile(e, docList.enrollmentId)} />


                          </div> */}
                          </li>
                        ))
                        }
                      </ul>

                      <label> Upload multiple files</label>
                      <input type="file" title="" id={item.id} multiple name={item.name} size="" onChange={this.handleChangeFileMultiple} />

                    </div>
                  )


                  : (<div className="upload-doc-multi"><label> Upload multiple files</label><input type="file" title="" id={item.id} multiple name={item.name} size="" onChange={this.handleChangeFileMultiple} /></div>)
              }
              {' '}
            </div>,
          );
          // UploadFields.push(
          //   <div className="uploadDoc" key={index}>
          //     <label className="file-name-upload">{item.name}</label>
          //     <input type="file" multiple id={item.id} name={item.name} size="" onChange={this.handleChangeFileMultiple} />
          //     {' '}
          //   </div>,
          // );
        }
        return true;
      });
    }

    return (
      <span>

        <SideMenu userName={UserName} />
        <div className="container">
          <header className="section">

            <div className="step-breadcrumb">
              <div className="col s12 center-align">
                <a className={ShowUploadScreen ? 'breadcrumb active' : 'breadcrumb '}>Upload Documents</a>

              </div>
            </div>
          </header>
          <Loader loaded={this.state.loaded} />
          <div className="main-content">
            <div className="divider hdr-bdr" />
            <div className="section-content left-align eligibility-check apply-eligibility">
              <div className="row">
                <div className="col s10 offset-s1">
                  <div className={ShowUploadScreen && !successUpload ? 'row' : 'hide'}>
                    <div className="col s12">
                      {/** new html* */}
                      <div className="upload-docs apply-docs">
                        <form action="#">
                          <h6>Document Upload</h6>
                          <span>Any supporting documents that optimize your enrollment will be shown below.</span>
                          <br />
                          <span>Please upload one or more files.</span>
                          <div>
                            {UploadFields.length > 0 ? (
                              <span>{UploadFields}</span>
                            ) : (
                                <span />
                              )}

                          </div>
                        </form>
                      </div>
                    </div>
                    {/** end new html* */}
                  </div>
                  <div className={successUpload ? 'row' : 'hide'}>
                    <div className="col s12 l2">
                      <div className="green-box">
                        <img className="responsive-img" src={categoryImage} alt={categoryName} />
                      </div>
                    </div>
                    <div className="col s12 l10">
                      <h5 className="enroll-formtext">
                        {/* <img src={thumbs} alt="" /> */}
                        You have successfully uploaded documents with Collectively for the
                        {' '}
                        {shortName}
                        {' '}
                        settlement.
                      </h5>
                      <p className="enroll-formparagraph"> Now you can just sit back and we'll handle the rest for you. If we happen to need additional information from you in regards to the settlement, we will contact you.</p>
                      <p>
                        {' '}
                        <Link to="/dashboard"> Click here </Link>
                        {' '}
                        to go back to dashboard
                        {' '}
                      </p>
                    </div>
                  </div>
                  <div className={ShowUploadScreen ? 'row' : 'show'}>
                    <div className="col s12 ">
                      <div className="divider hdr-bdr " />
                      <span className={UploadError ? 'error' : 'hide'}>Upload all the documents please</span>
                      <span className={UploadMessageError ? 'error' : 'hide'}>Please upload only image, pdf or docx</span>
                    </div>
                    <div className={ShowUploadScreen && !successUpload ? 'col s12 ' : 'col s12 hide'}>
                      <button className="btn waves-effect waves-light primary-btn col s6 offset-s3" type="submit" name="action" onClick={this.completeSteps}>
                        Finish

                      </button>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </span>
    );
  }
}

applyContainerDocument.contextTypes = {
  router: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({ data: state.data });

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    getSettlementById,
    saveToNextQuestionList,
    moveToNextQuestionList,
    saveSettlementAnswers,
    updateEnrollmenttDoc,
    saveEnrollmenttDoc,
    saveSettlementWithoutData,
    saveEnrollmentAuthorization,
    getPendingRequiredDocUser,
    getPendingRequiredDocUserDelete,
    getEligibilityQuestionById,
    getPendingSettlementQuestions,
  }, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(applyContainerDocument));
